import script from "./CompanyDeactivatedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDeactivatedModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDeactivatedModal.vue?vue&type=style&index=0&id=1c478720&scoped=true&lang=css"

import exportComponent from "/tmp/build_f763c173/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c478720"]])

export default __exports__